
import { i18nText } from '@/locales';
import {Form} from "@/form/form";
import {Validate} from "@/plugins/Vuelidate/Decorators";
import {required} from "vuelidate/lib/validators";
import {Component} from "vue-property-decorator";
import {RecoverCodeRequestType} from "@/form/recover/recoverCode/recoverCode.types";

@Component
export default class RecoverCodeForm extends Form{
    @Validate(required, i18nText("Введите код"))
    code = '';
    phone = '';
    getFormData(): RecoverCodeRequestType {
        return {
            code: this.code,
            phone: this.phone
        }
    }
}
